<template>
  <div id="app">
     <Loading />
    <router-view />
  </div>
</template>
<script>
import Loading from '@/components/Loading.vue'
import wx from './utils/wx.js'
export default {
  components: {
    Loading
  },
   created(){
   wx.hideMenu()
   }
}
</script>
<style>
  html{
  
 height: 100vh;
  /* 其他全局重置，如：*/
  /* box-sizing: border-box; */
}
body {
  margin: 0 !important; /* 使用 !important 确保覆盖优先级 */
  padding: 0;
 height: 100%;
  /* 其他全局重置，如：*/
  /* box-sizing: border-box; */
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
  height: 100%;
  
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
img {
  -webkit-touch-callout: none;  /* 禁用 iOS 长按菜单 */
  -webkit-user-drag: none;       /* 禁止拖拽 */
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  
  pointer-events: none;         /* 禁止所有鼠标/触摸事件 */
}

/* 如果图片需要点击，单独设置 */
img.clickable {
  pointer-events: auto;         /* 允许点击 */
  cursor: pointer;
}
</style>
